import { Object3D } from 'three/src/core/Object3D';
import { Box3 } from 'three/src/math/Box3';
import { Vector3 } from 'three/src/math/Vector3';
import { LineSegments } from 'three/src/objects/LineSegments';
import { Mesh } from 'three/src/objects/Mesh';

export const removeMesh = (object: Mesh) => object.traverse((child: Object3D) => {
    if (child instanceof LineSegments) object.remove(child);
});

export const resetCoords = (object: Mesh) => {
  object.updateMatrix();
  object.geometry.applyMatrix4(object.matrix);
  object.position.set(0, 0, 0);
  object.rotation.set(0, 0, 0);
  object.scale.set(1, 1, 1);
  object.updateMatrix();
};

export const moveToMin = (object: Mesh) => {
  const currentObject = object;
  const aabb = new Box3().setFromObject(object);
  // Compute the translation required to move the base to 0,0,0
  const translationY = -aabb.min.y; // Move the bottom of the object to y = 0

  // Set the new position for the object
  currentObject.position.y += translationY;
  resetCoords(currentObject);
};

export const centerObject = (object: Mesh) => {
  const aabb = new Box3().setFromObject(object); // Get the object's bounding box
  const center = aabb.getCenter(new Vector3());

  const newPosition = new Vector3(
    object.position.x - center.x,
    object.position.y - center.y,
    object.position.z - center.z,
  );

  object.position.add(newPosition);
  resetCoords(object);
};

export const rotateX = (object: Mesh) => {
  removeMesh(object);
  object.rotateX(-90 * (Math.PI / 180));
  centerObject(object);
  moveToMin(object);
  resetCoords(object);
};
